import React, { useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import { Typography, Card, List, Button, Grid } from "@material-ui/core";
import { LangContext } from "../../../Context/Langcontext";
import useReactRouter from "use-react-router";
const useStyle = makeStyles((theme) => ({
  root: {
    height: "100%",
    width: "100%",
    backgroundColor: "#FFFFFF",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    paddingBottom: "5rem",
  },
  insideroot: {
    height: "80%",
    width: "80%",
    backgroundColor: "#FFFFFF",
  },
  rootrow: {
    height: "100%",
    width: "100%",
    backgroundColor: "#FFFFFF",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "row",
    marginTop: -30,
  },
  btnstyle: {
    margin: "1rem",
    borderRadius: 8,
    padding: "0.4rem 2rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#E16733",
    color: "#FFFFFF",
    "&:hover": {
      background: "#E16733",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  cardStyle: {
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    minHeight: 400,
    height: "90%",
    backgroundColor: "#FFFFFF",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "column",
    textAlign: "center",
    width: "90%",
    paddingTop: "1.5rem",
    paddingBottom: "1rem",
    marginTop: "1.5rem",
    "&:hover": {
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  choicetext: {
    fontWeight: 200,
    whiteSpace: "break-spaces",
    textAlign: "center",
    padding: "0.5rem",
  },
  itemcard: {
    height: "100%",
    backgroundColor: "#FFFFFF",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "column",
    textAlign: "center",
    width: "100%",
    paddingBottom: "1rem",
  },
  grid: {
    maxWidth: "100%",
    width: "-webkit-fill-available",
  },
}));

const Pricingtype = () => {
  const classes = useStyle();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  const { history } = useReactRouter();

  const type = [
    {
      title: lang.Freetier,
      image: require("../../../images/graphic-icon/free_plan.png"),
      button: lang.Freeplan,
      push: "/user/login",
      request: [
        // { choice: "Landmark API\n(10000 requset)" },
        // { choice: "Address API\n(10000 requset)" },
        // { choice: "Search API\n(10000 requset)" },

        {
          choice:
            "Data Service ใช้งานฟรี 2 ข้อมูลแผนที่ฐาน\n สถานที่สำคัญ และ อาคาร",
        },
        { choice: "Map Service ใช้งานฟรี 5,000 ชิ้นงานในทุกชั้นข้อมูล" },
      ],
      choose: 0,
    },
    {
      title: lang.Payasyougo,
      image: require("../../../images/graphic-icon/pay_plan.png"),
      button: lang.Orderplan,
      push: "/user/login",
      request: [
        // { choice: "Landmark API\n($0.5 / 1000 requset)" },
        // { choice: "Address API\n($0.5 / 1000 requset)" },
        // { choice: "Search API\n($0.5 / 10000 requset)" },

        {
          choice:
            "Data Service ข้อมูลแผนที่ฐานทุกชั้นข้อมูล\n ยกเว้น ข้อมูลอาคาร และเส้นแบ่งอาคาร 0.58 บาท/kb\n ข้อมูลอาคาร และเส้นแบ่งอาคาร 2.73 บาท/kb\n ข้อมูลแผนที่ระบบไฟฟ้าทุกชั้นข้อมูล\n ยกเว้นข้อมูลเสา 113.46 บาท /kb\n  ข้อมูลเสา 4.85 บาท/kb",
        },
        { choice: "Map Service 16 บาท/1,000 ชิ้นงาน " },
      ],
      choose: 1,
    },
    {
      title: lang.Contact,
      image: require("../../../images/graphic-icon/contract_plane.png"),
      button: lang.Contactplan,
      push: "/home/support",
      request: [
        {
          choice:
            "ติดต่อเจ้าหน้าที่ \n เพื่อหาแพจเกจที่เหมาะสมกับความต้องการของคุณ",
        },
      ],
      choose: 0,
    },
  ];
  return (
    <div className={classes.root}>
      <div className={classes.insideroot}>
        <Grid
          container
          className={classes.rootrow}
          //  spacing={6}
        >
          {type.map((item) => {
            return (
              <Grid
                key={item.title}
                item
                md={4}
                sm={12}
                xs={12}
                className={classes.grid}
              >
                <Typography
                  style={{
                    // padding: "2rem 10rem",
                    color: "#E16733",
                    fontSize: "1.2rem",
                    fontWeight: 400,
                    whiteSpace: "nowrap",
                    textAlign: "center",
                    padding: "1rem",
                    borderTop: item.choose === 1 ? "2px solid" : "unset",
                    borderLeft: item.choose === 1 ? "2px solid" : "unset",
                    borderRight: item.choose === 1 ? "2px solid" : "unset",
                    borderBottom: item.choose === 1 ? "2px solid" : "unset",
                  }}
                >
                  {item.title}
                </Typography>

                <div className={classes.itemcard}>
                  <Card
                    className={classes.cardStyle}
                    style={{
                      border: item.choose === 1 ? "1px solid #E16733" : "unset",
                    }}
                  >
                    <img
                      alt={`image_${item.title}`}
                      src={item.image}
                      style={{ width: "6rem", height: "auto" }}
                    />
                    <List
                      style={{
                        height:
                          item.choose === 1
                            ? "calc(370px - 30px)"
                            : "calc(370px - 40px)",
                        overflowY: "auto",
                      }}
                    >
                      {item.request.map((rs, idex) => {
                        return (
                          <Typography
                            key={idex}
                            className={classes.choicetext}
                            align="left"
                          >
                            {rs.choice}
                          </Typography>
                        );
                      })}
                    </List>
                    <Button
                      className={classes.btnstyle}
                      onClick={() => {
                        history.push(item.push);
                      }}
                    >
                      {item.button}
                    </Button>
                  </Card>
                </div>
              </Grid>
            );
          })}
        </Grid>
      </div>
    </div>
  );
};

export default Pricingtype;
